// extracted by mini-css-extract-plugin
module.exports = {"MenuBg":"Menu_MenuBg__1yVgK","MenuWrapper":"Menu_MenuWrapper__1X2Xr"};